document.addEventListener("DOMContentLoaded", () => {

  /* === TIMER SETUP === */
  const timerEl = document.getElementById("bf-timer-countdown");

  const startDate = new Date("2025-12-01T00:00:00").getTime();

  // Fine: +48 ore
  const endDate = startDate + (48 * 60 * 60 * 1000);

  function updateTimer() {
    const now = Date.now();
    const distance = endDate - now;

    if (distance <= 0) {
      timerEl.textContent = "00:00:00";
      return;
    }

    const h = String(Math.floor(distance / (1000 * 60 * 60))).padStart(2, "0");
    const m = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
    const s = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");

    timerEl.textContent = `${h}:${m}:${s}`;
  }

  updateTimer();
  setInterval(updateTimer, 1000);

  /* === STICKY BEHAVIOR === */
  const timerBar = document.getElementById("bf-timer-bar");
  const mainMenu = document.querySelector('header'); // header principale

  function handleSticky() {
    const menuBottom = mainMenu.getBoundingClientRect().bottom;

    if (menuBottom <= 0) {
      timerBar.classList.add("bf-sticky");
    } else {
      timerBar.classList.remove("bf-sticky");
    }
  }

  document.addEventListener("scroll", handleSticky);
  handleSticky();
});
